import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useTranslation } from "react-i18next";
import classes from "./Activities.module.css";
import { testUrl } from "../BaseData";

const IlmiyKengash = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [category, setCategory] = useState(null);
  const [activityTypes, setActivityTypes] = useState([]);
  const [html, setHtml] = useState("");
  const [useFallback, setUseFallback] = useState(false);

  // Function to sort sidebar items to match navbar order
  const sortSidebarItems = (items) => {
    const navbarOrder = [
      'ilmiy-jarayonlar',
      'ilmiy-kengash',
      'ilmiy-konferensiyalar',
      'journal',
      'ilmiy-maktablar',
      'green-renessans',
      'oquv-va-labaratoriya-bazalari',
      'axborotlashtirish-jarayonlari',
      'yosh-akademiklar',
      'avtorefereat-dissertatsiya'
    ];

    return items.sort((a, b) => {
      const aIndex = navbarOrder.indexOf(a.short_name);
      const bIndex = navbarOrder.indexOf(b.short_name);

      // If both items are in the navbar order, sort by their position
      if (aIndex !== -1 && bIndex !== -1) {
        return aIndex - bIndex;
      }

      // If only one item is in the navbar order, prioritize it
      if (aIndex !== -1) return -1;
      if (bIndex !== -1) return 1;

      // If neither item is in the navbar order, keep original order
      return 0;
    });
  };

  useEffect(() => {
    setLoading(true);
    setError(null);
    setUseFallback(false);

    const fetchSidebar = axios.get(testUrl + "/api/baseactivity/ilmiy-faoliyat/");
    const fetchContent = axios.get(testUrl + "/api/baseactivity/ilmiy-faoliyat/ilmiy-kengash");

    Promise.all([fetchSidebar, fetchContent])
      .then(([sidebarRes, contentRes]) => {
        const sb = sidebarRes.data;
        if (sb) {
          setCategory(sb.category || null);
          // Sort the sidebar items to match navbar order
          const sortedItems = sortSidebarItems(sb.activity_types || []);
          setActivityTypes(sortedItems);
        }
        const details = contentRes.data;
        if (details && details.activity) {
          const lang = i18n.language;
          setHtml(details.activity[`site_details_${lang}`] || details.activity[`site_details_uz`] || "");
        } else {
          setUseFallback(true);
        }
      })
      .catch(() => {
        setError("Ma'lumotlarni yuklashda xatolik");
        setUseFallback(true);
      })
      .finally(() => setLoading(false));
  }, [i18n.language]);

  if (loading) return <div>Yuklanmoqda...</div>;

  const currentShort = "ilmiy-kengash";

  // Fallback content when API fails
  const fallbackContent = `
    <div class="university-info">
      <h2>Ilmiy kengash haqida</h2>
      <p>Renessans Universiteti ilmiy kengashi universitetning ilmiy faoliyatini muvofiqlashtirish, 
      ilmiy loyihalarni ko'rib chiqish va ilmiy yo'nalishlarni belgilash bo'yicha asosiy organ hisoblanadi.</p>
      
      <h3>Asosiy vazifalari:</h3>
      <ul>
        <li>Ilmiy tadqiqot yo'nalishlarini belgilash va muvofiqlashtirish</li>
        <li>Ilmiy loyihalarni ko'rib chiqish va tasdiqlash</li>
        <li>Xalqaro hamkorlik dasturlarini rivojlantirish</li>
        <li>Ilmiy salohiyatni oshirish choralarini ko'rish</li>
        <li>Zamonaviy ilmiy yutuqlarni amaliyotga joriy etish</li>
      </ul>
      
      <p>Ilmiy kengash universitetning ilmiy salohiyatini oshirish, xalqaro hamkorlikni kengaytirish 
      va zamonaviy ilmiy yutuqlarni amaliyotga joriy etish yo'nalishida faol ishlaydi.</p>
    </div>
  `;

  return (
    <div className={classes["mainContainer"]}>
      <div data-aos="fade-up" className={classes["container"]}>
        <h1 className={classes["page-title"]}>{t("Ilmiy kengash")}</h1>
        {useFallback ? (
          <div dangerouslySetInnerHTML={{ __html: fallbackContent }} />
        ) : (
          <div dangerouslySetInnerHTML={{ __html: html }} />
        )}
      </div>
      <div className={classes.sidebar}>
        <h3>{category ? category[`name_${i18n.language}`] : t("categories")}</h3>
        <ul>
          {activityTypes.map((cat) => (
            <li
              key={cat.id}
              className={cat.short_name === currentShort ? classes.active : ""}
              onClick={() => navigate(`/activity/${category.short_name}/${cat.short_name}`)}
            >
              {cat[`name_${i18n.language}`]}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default IlmiyKengash; 